module.exports = __webpack_public_path__ + "img/premium.f736d26e.svg";